import React, { useContext, useEffect, useState, useRef, useMemo } from "react";
import "../styles/Home.css";
import { GameContext } from "../context/GameContext";
import NumberSelectionScreen from "./NumberSelectionScreen";
import TimerDate from "./TimerDate";
import PWATimerDate from "./PWATimerDate";
import { Limit } from "./Limit";
import GamesAndClosing from "./GamesAndClosing";
import { TimerProvider } from "../context/TimerContext";
import Amount from "./Amount";
import Results from "./Results";
import { PlayGame1 } from "./PlayGame1";
import { SelectedNumbersList } from "./SelectedNumberList";
import { Banker } from "./Banker";
import { game1, game2, getTimeRemaining } from "./TimerDateUtils";
import Services from "./Services";
import { LotteryResults2 } from "./LotteryResults2";
import Advert from "./Advert";
import playstoreLogo from "../Images/pstore1.png";
import iosLogo from "../Images/ios1.png";
import mondayLogo from "../Images/MONDAY.png";
import tuesdayLogo from "../Images/TUESDAY.png";
import wednesdayLogo from "../Images/MIDWEEK.png";
import thursdayLogo from "../Images/THURSDAY.png";
import fridayLogo from "../Images/FRIDAY.png";
import SUNDAY from "../Images/SUNDAY.png";
import NATIONAL from "../Images/NATIONAL.png";
import { WhyChooseUs } from "./WhyChooseUs";
import ballImage from "../Images/BALLS.jfif";
import { useNavigate } from "react-router-dom";
import PendingTicket from "./PendingTicket";
import { TimerContext } from "../context/TimerContext";
import { getCurrentBankerNumbers } from "../utils/bankerNumbers";

function formatTo12Hour(timeStr) {
  if (!timeStr) return "";
  const [hour, minute] = timeStr.split(":");
  let h = parseInt(hour, 10);
  const ampm = h >= 12 ? "PM" : "AM";
  h = h % 12 || 12;
  return `${h}:${minute} ${ampm}`;
}

const Home = () => {
  const {
    limit,
    limitLabel,
    selectedNumbers,
    againstNumbers,
    amount,
    setAmount,
    minimumWin,
    maximumWin,
    price,
    lines,
  } = useContext(GameContext);

  const [selectedGame, setSelectedGame] = useState(null);
  const [bankerNumbers, setBankerNumbers] = useState([]);
  const [pendingTicket, setPendingTicket] = useState(() => {
    try {
      const stored = localStorage.getItem("pendingTicket");
      return stored ? JSON.parse(stored) : [];
    } catch (e) {
      return [];
    }
  });
  const navigate = useNavigate();
  const playGame1Ref = useRef();
  const { commissionPercentage } = useContext(TimerContext);

  const { isPWA, isWebView } = useMemo(() => {
    if (typeof window === "undefined") return { isPWA: false, isWebView: false };
    const isStandalone = window.matchMedia && window.matchMedia("(display-mode: standalone)").matches;
    const isNavigatorStandalone = window.navigator.standalone === true;
    const isPWA = !!(isStandalone || isNavigatorStandalone);
    const ua = navigator.userAgent || "";
    const isAndroidWebView = /\bwv\b/.test(ua) || (/Android/.test(ua) && /Version\/\d+\./.test(ua));
    const isIOSWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/.test(ua);
    const isReactNativeWebView = !!window.ReactNativeWebView;
    const isWebView = isReactNativeWebView || isAndroidWebView || isIOSWebView;
    return { isPWA, isWebView };
  }, []);

  useEffect(() => {
    const fetchGameTimes = () => {
      const game1Times = getTimeRemaining(game1);
      const game2Times = getTimeRemaining(game2);
      const allGames = [...game1Times, ...game2Times].sort((a, b) => {
        const timeA = new Date(a.nextGameStartTime).getTime();
        const timeB = new Date(b.nextGameStartTime).getTime();
        return timeA - timeB;
      });
      setSelectedGame(allGames[0]);
    };

    fetchGameTimes();
    const interval = setInterval(fetchGameTimes, 1000);
    return () => clearInterval(interval);
  }, []);

  // Save pending tickets to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem("pendingTicket", JSON.stringify(pendingTicket));
  }, [pendingTicket]);

  useEffect(() => {
    const loadBankerNumbers = () => {
      setBankerNumbers(getCurrentBankerNumbers());
    };

    loadBankerNumbers();
    const syncInterval = setInterval(loadBankerNumbers, 60000);
    return () => clearInterval(syncInterval);
  }, []);

  return (
    <div className="home-container">
      {!isPWA && (
        <div className="animated-background">
          <div className="circle">64</div>
          <div className="circle">05</div>
          <div className="circle">20</div>
          <div className="circle">55</div>
          <div className="circle">88</div>

          <div className="row hero-row">
            <div className="hero-info">
              <div className="hero-announcement">
                <span className="hero-badge">
                  {selectedGame ? selectedGame.d : "Sunday Aseda"}
                </span>
                <span className="hero-time">
                  closes at{" "}
                  {selectedGame
                    ? formatTo12Hour(selectedGame.closingTime)
                    : "5:50 pm"}{" "}
                  on HuntexLotto
                </span>
              </div>
              <h2 className="hero-title">Your Lucky day is Here!</h2>
              <h1>Win Big In Your Favorite Lottery Now!</h1>
              <ul className="hero-features">
                <li>Play from the comfort of your home</li>
                <li>No more lost tickets; get instant results after the draw</li>
                <li className="highlight">
                  Get your numbers in before the draw closes!
                </li>
              </ul>
              <div
                className="download-row"
                style={{
                  display: "flex",
                  gap: "18px",
                  marginTop: "50px",
                  justifyContent: "center",
                }}
              >
                {/*<a
                  href="https://drive.google.com/file/d/1VaJg7J16VNBPkVjAPsvNMTwjphMupGiK/view?usp=drive_link"
                  download
                  style={{ textDecoration: "none" }}
                >
                  <button className="download-btn">
                    <img
                      src={playstoreLogo}
                      alt="Play Store"
                      style={{
                        width: "30px",
                        height: "30px",
                        marginRight: "8px",
                        verticalAlign: "middle",
                      }}
                    />
                    Get Android App
                  </button>
                </a>
                <a download style={{ textDecoration: "none" }}>
                  <button className="download-b">
                    <img
                      src={iosLogo}
                      alt="Play Store"
                      style={{
                        width: "40px",
                        height: "40px",
                        marginRight: "8px",
                        verticalAlign: "middle",
                      }}
                    />
                    App
                  </button>
                </a>*/}
              </div>
              <button
                className="register-btn"
                onClick={() => navigate("/Register")}
                style={{
                  marginTop: "18px",
                  padding: "12px 28px",
                  background:
                    "linear-gradient(90deg, #d81da9ff 60%, #2563eb 100%)",
                  color: "#fff",
                  fontWeight: "200",
                  fontSize: "1.2rem",
                  width: "200px",
                  height: "60px",
                  margin: "50px",
                  border: "1px solid #0e0405",
                  borderRadius: "8px",
                  cursor: "pointer",
                  boxShadow: "0 2px 8px rgba(44,62,80,0.10)",
                  transition: "background 0.2s",
                }}
              >
                SignUp
              </button>
              
            </div>

            <div
              className="images"
              style={{
                flexDirection: "column",
                alignItems: "center",
                display: "flex",
              }}
            >
              <div
                className="images"
                style={{
                  display: "flex",
                  gap: "24px",
                  alignItems: "center",
                  margin: "16px 0",
                }}
              >
                <img
                  src={mondayLogo}
                  alt="MONDAY"
                  style={{
                    width: "150px",
                    height: "150px",
                    boxShadow: "0 2px 8px rgba(44,62,80,0.18)",
                    objectFit: "cover",
                    display: "block",
                  }}
                />
                <img
                  src={tuesdayLogo}
                  alt="Lucky Tuesday"
                  style={{
                    width: "150px",
                    height: "150px",
                    objectFit: "contain",
                    display: "block",
                  }}
                />
                <img
                  src={wednesdayLogo}
                  alt="MIDAWEEK"
                  style={{
                    width: "180px",
                    height: "70px",
                    objectFit: "cover",
                    borderRadius: "12px",
                    display: "block",
                  }}
                />
              </div>

              <div
                style={{
                  display: "flex",
                  gap: "24px",
                  alignItems: "center",
                  margin: "16px 0",
                }}
              >
                <img
                  src={thursdayLogo}
                  alt="THURSDAY"
                  style={{
                    width: "150px",
                    height: "130px",
                    boxShadow: "0 2px 8px rgba(44,62,80,0.18)",
                    objectFit: "cover",
                    display: "block",
                  }}
                />
                <img
                  src={fridayLogo}
                  alt="FRIDAY"
                  style={{
                    width: "180px",
                    height: "150px",
                    objectFit: "contain",
                    display: "block",
                  }}
                />
                <img
                  src={NATIONAL}
                  alt="NATIONAL"
                  style={{
                    width: "150px",
                    height: "100px",
                    objectFit: "cover",
                    borderRadius: "12px",
                    display: "block",
                  }}
                />
              </div>
              <div>
                <img
                  src={SUNDAY}
                  alt="SUNDAY"
                  style={{
                    width: "150px",
                    height: "100px",
                    objectFit: "cover",
                    borderRadius: "12px",
                    display: "block",
                  }}
                />
              </div>
            </div>
          </div>
          
        </div>
      )}

      {isPWA && (
        <div className="pwa-timer-section">
          <PWATimerDate />
        </div>
      )}
{!isPWA && (
      <div className="timer">
        <TimerDate selectedGame={selectedGame} />
      </div>)}

    <div className="commission-wrapper">
        <div className="commission-inner">
          <div className="commission-left">
            <div className="commission-header">
              <span>Today's Commission</span>
              <strong>{(commissionPercentage * 100)}%</strong>
            </div>
            <p className="commission-tagline">
              Keep {commissionPercentage * 100}% of every stake with one of the highest commissions on the market.
            </p>
            <button
              className="commission-cta"
              onClick={() => {
                const el = document.getElementById("number-selection");
                if (el) {
                  el.scrollIntoView({ behavior: "smooth", block: "start" });
                }
              }}
            >
              Click to Play
            </button>
          </div>
          <ul className="commission-list">
            <li>More cash back into your pocket on every ticket</li>
            <li>Transparent charges shown before you play</li>
            <li>Fair odds + high commission = bigger payouts</li>
            <li>Share you booking code with friends</li>
            <li>Play even if you have no odds, scroll through other games played & stake</li>
          </ul>
          <div className="commission-banker-mini">
            <span className="commission-banker-title">Banker</span>
            <div className="commission-banker-numbers">
              {bankerNumbers.length > 0 ? (
                bankerNumbers.map((number, index) => (
                  <span className="commission-banker-pill" key={`${number}-${index}`}>
                    {number}
                  </span>
                ))
              ) : (
                <span className="commission-banker-pill">--</span>
              )}
            </div>
          </div>
        </div>
      </div>
     

      <div>
        {isWebView && <WhyChooseUs />}
      </div>
       <div >
        {isWebView && <Banker />}
      </div>
      <div className="background-image">
        <div className="background-overlay">
          <div className="card2">
            <GamesAndClosing />
            <Limit />
          </div>
          <div className="card2-row">
            <NumberSelectionScreen />
            <div className="margin">
              <Amount amount={amount} setAmount={setAmount} />
              <Results
                price={price}
                minimumWin={minimumWin}
                maximumWin={maximumWin}
                lines={lines}
                limit={limit}
                limitLabel={limitLabel}
              />
              <SelectedNumbersList />
              <div style={{ left: "25%" }}>
                <PlayGame1
                  ref={playGame1Ref}
                  setPendingTicket={setPendingTicket}
                  selectedNumbers={selectedNumbers}
                  price={price}
                  againstNumbers={againstNumbers}
                  minimumWin={minimumWin}
                  maximumWin={maximumWin}
                  amount={amount}
                />
              </div>
            </div>
          </div>
          <div>
            {pendingTicket && (
              <PendingTicket
                ticket={pendingTicket}
                setPendingTicket={setPendingTicket}
                confirmInfo={
                  playGame1Ref.current
                    ? playGame1Ref.current.confirmInfo
                    : undefined
                }
              />
            )}
          </div>
        </div>
      </div>

      <div className="services-section">
          {isWebView && (
            <Services
              maxItems={6}
              showHero={false}
              showViewAll={true}
              showPagination={false}
              withBg={false}
              homeBg="light"
            />
          )}
      </div>

      <div className="footer">
        <Advert />
      </div>
    </div>
  );
};

export default Home;
